import angular from 'angular';
import { AddressComponent } from './address.component';
import { AddressFormModule } from './form';
import { AddressStaticModule } from './static';
import { AddressValidatorsModule } from './validators';
import { AddressVerifierServiceModule } from './verifier';

export const AddressModule = angular
  .module('angular-common.address', [
    AddressFormModule.name,
    AddressStaticModule.name,
    AddressValidatorsModule.name,
    AddressVerifierServiceModule.name,
  ])
  .component('updAddress', AddressComponent);
